.loading {
  & :global(.rt-SelectIcon) {
    display: none;
  }

  & :global(.rt-SelectTriggerInner) {
    margin: 0 auto;
  }
}
